const handleErrorRequest = (response) => {
	if (response.status >= 400 && response.status < 500) {
		return response.json().then((json) => Promise.reject(json));
	}

	return response.json();
};

export default handleErrorRequest;



// WEBPACK FOOTER //
// ./src/js/request/handleErrorRequest.js